package game.entity

import EntityDef
import game.Game
import game.Room
import game.createEntity

class Spawner() : Entity() {
    var onSpawn: (Entity) -> Unit = {}
    var onDespawn: (Entity) -> Unit = {}

    private lateinit var entityDef: EntityDef
    private var count = 0
    private var enemy: Enemy? = null

    override fun onInit(game: Game, room: Room) {
        val parts = params.split(",")
        val type = parts[0]

        count = parts[1].toInt()

        entityDef = EntityDef("", type, col, row)
    }

    override fun onTick(game: Game, room: Room) {
        if (enemy == null && count != 0) {
            enemy = createEntity(entityDef) as Enemy
            enemy?.onDeath = {
                onDespawn(enemy!!)

                enemy = null
            }

            room.addEntity(enemy!!)

            onSpawn(enemy!!)

            count--
        }

        if (count == 0) {
            room.removeEntity(this)
        }
    }
}
